// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.globalNavbar {
    background-color: var(--topbarColor);
    margin: 0;
}
.containerTopBar {
    position: relative;
    z-index: 20;
    background-color: var(--topbarColor);
    border: 1px solid var(--topbarColor);
    width: 100%;
    box-shadow: 0 6px 6px rgba(0, 0, 0, 0.4);
}
.containterTop {
    background-color: var(--topbarColor);
}

.topBarBranding {
    font-size: 28px;
    cursor: pointer;
    font-family: var(--googleFont);
    font-style: italic;
    font-weight: 900;
}
.topBarBranding2 {
    margin-left: 2px;
    font-size: 28px;
    color: var(--HighlightBlue);
    cursor: pointer;
}
.topBarTopWraper {
    display: flex;
    justify-content: space-between;

    align-items: center;
    width: 100%;
    max-height: 56px;
}

.usernameContainer {
    display: flex;
    gap: 0.5em;
    margin-right: 70px;
}
.usernameContainer:hover {
    cursor: pointer;
}
.userLogoMenu {
    width: 2em;
    border-radius: 100%;
}

.userNameDisplay {
    padding: 2px 10px;
    background-color: var(--middelColor);
    color: var(--topbarSelectorColor);
    border-radius: 5px;
}
.logoTopBarContainer {
    margin-top: auto;
    margin-bottom: auto;
}
.topBarTitleBar {
    text-align: left;
    margin-left: 40px;
}
.titleAndBrandingContainer {
    display: flex;
    flex-wrap: nowrap;
    gap: 2em;
    margin-left: 10px;
}
.titleAndBrandingContainer h1 {
    white-space: nowrap;
}
.topTitleText {
    color: var(--TopBarHeaderTitle);
    font-size: 28px;
    font-family: var(--googleFont);
    font-style: italic;
    font-weight: 900;
    margin-top: auto;
    margin-bottom: auto;
}

.topNavbar {
    list-style-type: none;
    display: flex;
    flex-wrap: wrap;
    gap: 1em;

    margin-top: 0;
}

.topNavbar li {
    z-index: 1;
    text-align: center;
    font-size: 1em;
}

.topNavbar a:hover {
    cursor: pointer;
    border-bottom: 2px solid var(--HighlightBlue);
    color: var(--HighlightBlue);
}

.topNavbar a {
    text-decoration: none;
    font-weight: 900;
}

.activeLi {
    border-bottom: 2px solid var(--HighlightBlue);
    color: var(--HighlightBlue);
}
.inactiveLi {
    color: var(--Gray);
}

@media only screen and (max-width: 750px) {
    .topBarBranding {
        display: none;
    }
    .topBarBranding2 {
        display: none;
    }
    .topTitleText {
        font-size: 18px;
    }
    .containterTop {
        justify-content: left;
        font-size: 12px;
    }
    .userLogoMenu {
        display: none;
    }
    .userNameDisplay {
        padding: 4px 4px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Menus/TopMenu/topMenu.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,oCAAoC;IACpC,oCAAoC;IACpC,WAAW;IACX,wCAAwC;AAC5C;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;;IAE9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;IACpC,iCAAiC;IACjC,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,QAAQ;IACR,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,+BAA+B;IAC/B,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,eAAe;IACf,QAAQ;;IAER,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;IAC7C,2BAA2B;AAC/B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,qBAAqB;QACrB,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".globalNavbar {\n    background-color: var(--topbarColor);\n    margin: 0;\n}\n.containerTopBar {\n    position: relative;\n    z-index: 20;\n    background-color: var(--topbarColor);\n    border: 1px solid var(--topbarColor);\n    width: 100%;\n    box-shadow: 0 6px 6px rgba(0, 0, 0, 0.4);\n}\n.containterTop {\n    background-color: var(--topbarColor);\n}\n\n.topBarBranding {\n    font-size: 28px;\n    cursor: pointer;\n    font-family: var(--googleFont);\n    font-style: italic;\n    font-weight: 900;\n}\n.topBarBranding2 {\n    margin-left: 2px;\n    font-size: 28px;\n    color: var(--HighlightBlue);\n    cursor: pointer;\n}\n.topBarTopWraper {\n    display: flex;\n    justify-content: space-between;\n\n    align-items: center;\n    width: 100%;\n    max-height: 56px;\n}\n\n.usernameContainer {\n    display: flex;\n    gap: 0.5em;\n    margin-right: 70px;\n}\n.usernameContainer:hover {\n    cursor: pointer;\n}\n.userLogoMenu {\n    width: 2em;\n    border-radius: 100%;\n}\n\n.userNameDisplay {\n    padding: 2px 10px;\n    background-color: var(--middelColor);\n    color: var(--topbarSelectorColor);\n    border-radius: 5px;\n}\n.logoTopBarContainer {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n.topBarTitleBar {\n    text-align: left;\n    margin-left: 40px;\n}\n.titleAndBrandingContainer {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 2em;\n    margin-left: 10px;\n}\n.titleAndBrandingContainer h1 {\n    white-space: nowrap;\n}\n.topTitleText {\n    color: var(--TopBarHeaderTitle);\n    font-size: 28px;\n    font-family: var(--googleFont);\n    font-style: italic;\n    font-weight: 900;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.topNavbar {\n    list-style-type: none;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1em;\n\n    margin-top: 0;\n}\n\n.topNavbar li {\n    z-index: 1;\n    text-align: center;\n    font-size: 1em;\n}\n\n.topNavbar a:hover {\n    cursor: pointer;\n    border-bottom: 2px solid var(--HighlightBlue);\n    color: var(--HighlightBlue);\n}\n\n.topNavbar a {\n    text-decoration: none;\n    font-weight: 900;\n}\n\n.activeLi {\n    border-bottom: 2px solid var(--HighlightBlue);\n    color: var(--HighlightBlue);\n}\n.inactiveLi {\n    color: var(--Gray);\n}\n\n@media only screen and (max-width: 750px) {\n    .topBarBranding {\n        display: none;\n    }\n    .topBarBranding2 {\n        display: none;\n    }\n    .topTitleText {\n        font-size: 18px;\n    }\n    .containterTop {\n        justify-content: left;\n        font-size: 12px;\n    }\n    .userLogoMenu {\n        display: none;\n    }\n    .userNameDisplay {\n        padding: 4px 4px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
